{
  "familyId": "REK-TAFELS-BASIS",
  "questions": [
    {
      "id": "REK-TAFELS-BASIS-001",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "fill_in",
      "question": "Hoeveel is 7 × 8?",
      "options": [],
      "correctAnswer": "56",
      "data": {
        "acceptedAnswers": ["56"]
      },
      "conceptId": "tafels_moeilijke_combinatie",
      "equivalenceClass": "recall-fluency",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.62,
      "context": "Tafel van 7",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [7, 14, 21, 28, 35, 42, 49, 56, 63, 70],
            "marked": [56],
            "columns": 10,
            "label": "Tafel van 7"
          }
        }
      ],
      "feedback": {
        "explanationText": "7 × 8 = 56. Dit is een van de lastigste tafelsommen. Een handige truc: 5-6-7-8. De cijfers staan op volgorde! Je kunt ook denken: 7 × 8 = 7 × 7 + 7 = 49 + 7 = 56.",
        "solutionSteps": [
          "Zoek 7 × 8 in je geheugen",
          "Truc: 5-6-7-8 → het antwoord is 56",
          "Of: 7 × 7 = 49, plus nog 1 × 7 = 49 + 7 = 56"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-002",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "fill_in",
      "question": "Hoeveel is 6 × 9?",
      "options": [],
      "correctAnswer": "54",
      "data": {
        "acceptedAnswers": ["54"]
      },
      "conceptId": "tafels_negen_truc",
      "equivalenceClass": "recall-fluency",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.65,
      "context": "Tafel van 9",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [9, 18, 27, 36, 45, 54, 63, 72, 81, 90],
            "marked": [54],
            "columns": 10,
            "label": "Tafel van 9"
          }
        }
      ],
      "feedback": {
        "explanationText": "6 × 9 = 54. Bij de tafel van 9 is er een handige truc: de cijfers van het antwoord tellen altijd op tot 9. Hier: 5 + 4 = 9. Je kunt ook denken: 6 × 10 = 60, min 6 = 54.",
        "solutionSteps": [
          "Zoek 6 × 9 in je geheugen",
          "Truc 1: 6 × 10 = 60, min 1 × 6 = 60 − 6 = 54",
          "Truc 2: cijfersom van 54 is 5 + 4 = 9 ✓"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-003",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "fill_in",
      "question": "Hoeveel is 8 × 6?",
      "options": [],
      "correctAnswer": "48",
      "data": {
        "acceptedAnswers": ["48"]
      },
      "conceptId": "tafels_verdubbel_strategie",
      "equivalenceClass": "recall-fluency",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.64,
      "context": "Tafel van 8",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [8, 16, 24, 32, 40, 48, 56, 64, 72, 80],
            "marked": [48],
            "columns": 10,
            "label": "Tafel van 8"
          }
        }
      ],
      "feedback": {
        "explanationText": "8 × 6 = 48. Een handige aanpak: 8 × 6 is hetzelfde als 6 × 8. Je kunt ook verdubbelen: 4 × 6 = 24, dan verdubbelen → 48. Of splits: 8 × 5 = 40, plus 8 × 1 = 8, samen 48.",
        "solutionSteps": [
          "Zoek 8 × 6 in je geheugen",
          "Handige aanpak: 4 × 6 = 24, verdubbelen → 48",
          "Of: 8 × 5 = 40, plus 8 = 48"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-004",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "multiple_choice",
      "question": "Je speelt een game en verzamelt loot: 9 kisten met elk 7 edelstenen. Hoeveel edelstenen heb je in totaal?",
      "options": ["63", "56", "72", "54"],
      "correctAnswer": 0,
      "conceptId": "tafels_context_rijen",
      "equivalenceClass": "recall-context-mc",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.68,
      "context": "Gaming loot",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          {
            "id": "rek.multiplication-table-error",
            "label": "Tafelfout (8x7)",
            "optionIndex": 1
          },
          {
            "id": "rek.multiplication-table-error",
            "label": "Tafelfout (9x8)",
            "optionIndex": 2
          },
          {
            "id": "rek.multiplication-table-error",
            "label": "Tafelfout (9x6)",
            "optionIndex": 3
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [9, 18, 27, 36, 45, 54, 63, 72, 81, 90],
            "marked": [63],
            "columns": 10,
            "label": "Tafel van 9"
          }
        }
      ],
      "feedback": {
        "explanationText": "9 kisten van 7 edelstenen = 9 × 7 = 63. Bij 'kisten met elk' vermenigvuldig je het aantal kisten met het aantal per kist.",
        "solutionSteps": [
          "Lees: 9 kisten met 7 edelstenen",
          "Bewerking: 9 × 7",
          "Antwoord: 63"
        ],
        "distractorExplanations": {
          "0": "Goed! 9 × 7 = 63. Je vermenigvuldigt het aantal kisten met het aantal edelstenen per kist.",
          "1": "Je dacht waarschijnlijk aan 8 × 7 = 56. Maar er zijn 9 kisten, niet 8. Onthoud: lees het aantal kisten goed.",
          "2": "Je dacht waarschijnlijk aan 9 × 8 = 72. Maar er liggen 7 edelstenen per kist, niet 8. Onthoud: lees het aantal per kist goed.",
          "3": "Je dacht waarschijnlijk aan 9 × 6 = 54. Maar er liggen 7 edelstenen per kist, niet 6. Onthoud: 9 × 7 = 63."
        }
      }
    },
    {
      "id": "REK-TAFELS-BASIS-005",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "multiple_choice",
      "question": "Hoeveel is 4 × 7?",
      "options": ["24", "28", "32", "21"],
      "correctAnswer": 1,
      "conceptId": "tafels_vier_verdubbel",
      "equivalenceClass": "recall-fluency",
      "variantIndex": 5,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.60,
      "context": "Tafel van 4",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [4, 8, 12, 16, 20, 24, 28, 32, 36, 40],
            "marked": [28],
            "columns": 10,
            "label": "Tafel van 4"
          }
        }
      ],
      "feedback": {
        "explanationText": "4 × 7 = 28. De tafel van 4 kun je afleiden door de tafel van 2 te verdubbelen: 2 × 7 = 14, verdubbel → 28.",
        "solutionSteps": [
          "Zoek 4 × 7 in je geheugen",
          "Of: 2 × 7 = 14, verdubbelen → 28"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-006",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "multiple_choice",
      "question": "Welk getal ontbreekt in de reeks? 8, 16, 24, ___, 40, 48",
      "options": ["32", "30", "28", "36"],
      "correctAnswer": 0,
      "conceptId": "tafels_reeks_herkennen",
      "equivalenceClass": "pattern-sequence",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.66,
      "context": "Tafel van 8 reeks",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          {
            "id": "rek.multiplication-table-error",
            "label": "Patroonfout (+6)",
            "optionIndex": 1
          },
          {
            "id": "rek.multiplication-table-error",
            "label": "Tafel van 4 verward",
            "optionIndex": 2
          },
          {
            "id": "rek.multiplication-table-error",
            "label": "Patroonfout (+12)",
            "optionIndex": 3
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [8, 16, 24, 32, 40, 48, 56, 64, 72, 80],
            "marked": [32],
            "columns": 10,
            "label": "Tafel van 8"
          }
        }
      ],
      "feedback": {
        "explanationText": "Dit is de tafel van 8. Elk getal is 8 meer dan het vorige: 24 + 8 = 32. De volledige reeks: 8, 16, 24, 32, 40, 48.",
        "solutionSteps": [
          "Herken het patroon: elk getal is 8 meer",
          "Na 24: 24 + 8 = 32",
          "Check: 32 + 8 = 40 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De tafel van 8: na 24 komt 24 + 8 = 32.",
          "1": "Je dacht waarschijnlijk dat het patroon +6 is (24 + 6 = 30). Maar kijk naar het verschil: 16 − 8 = 8, 24 − 16 = 8. Het patroon is +8, niet +6.",
          "2": "Je dacht waarschijnlijk aan de tafel van 4 (28 = 4 × 7). Maar dit is de tafel van 8. Kijk naar het verschil tussen de getallen: steeds +8.",
          "3": "Je dacht waarschijnlijk dat het patroon +12 is (24 + 12 = 36). Maar het verschil is steeds 8: 16 − 8 = 8, 24 − 16 = 8. Dus na 24 komt 32."
        }
      }
    },
    {
      "id": "REK-TAFELS-BASIS-007",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "multiplication_grid",
      "question": "Vul de ontbrekende antwoorden in de tafel van 7",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "single_table",
        "baseNumber": 7,
        "range": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        "hiddenCells": [2, 4, 6, 7]
      },
      "conceptId": "tafels_grid_zeven",
      "equivalenceClass": "single-table-grid",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.64,
      "context": "Tafel van 7 rooster",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [7, 14, 21, 28, 35, 42, 49, 56, 63, 70],
            "columns": 10,
            "label": "Tafel van 7"
          }
        }
      ],
      "feedback": {
        "explanationText": "De tafel van 7: de ontbrekende antwoorden zijn 7×3=21, 7×5=35, 7×7=49 en 7×8=56. Kijk naar het patroon: elk antwoord is steeds 7 meer dan het vorige.",
        "solutionSteps": [
          "7 × 3 = 21 (7 + 7 + 7, of 7 × 2 + 7 = 14 + 7)",
          "7 × 5 = 35 (de helft van 7 × 10 = 70)",
          "7 × 7 = 49 (7 × 7 is een kwadraat)",
          "7 × 8 = 56 (49 + 7, of onthoud: 5-6-7-8)"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-008",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "multiplication_grid",
      "question": "Vul de ontbrekende antwoorden in de tafel van 8",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "single_table",
        "baseNumber": 8,
        "range": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        "hiddenCells": [3, 5, 6, 8]
      },
      "conceptId": "tafels_grid_acht",
      "equivalenceClass": "single-table-grid",
      "variantIndex": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.62,
      "context": "Tafel van 8 rooster",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [8, 16, 24, 32, 40, 48, 56, 64, 72, 80],
            "columns": 10,
            "label": "Tafel van 8"
          }
        }
      ],
      "feedback": {
        "explanationText": "De tafel van 8: de ontbrekende antwoorden zijn 8×4=32, 8×6=48, 8×7=56 en 8×9=72. Tip: de tafel van 8 is de tafel van 4 verdubbeld!",
        "solutionSteps": [
          "8 × 4 = 32 (verdubbel 4 × 4 = 16 → 32)",
          "8 × 6 = 48 (verdubbel 4 × 6 = 24 → 48)",
          "8 × 7 = 56 (onthoud: 5-6-7-8)",
          "8 × 9 = 72 (8 × 10 = 80, min 8 = 72)"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-009",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "multiplication_grid",
      "question": "Vul de ontbrekende antwoorden in de tafel van 6",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "single_table",
        "baseNumber": 6,
        "range": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        "hiddenCells": [3, 5, 7, 8]
      },
      "conceptId": "tafels_grid_zes",
      "equivalenceClass": "single-table-grid",
      "variantIndex": 9,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.64,
      "context": "Tafel van 6 rooster",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [6, 12, 18, 24, 30, 36, 42, 48, 54, 60],
            "columns": 10,
            "label": "Tafel van 6"
          }
        }
      ],
      "feedback": {
        "explanationText": "De tafel van 6: de ontbrekende antwoorden zijn 6×4=24, 6×6=36, 6×8=48 en 6×9=54. Tip: de tafel van 6 is de tafel van 3 verdubbeld! 3×4=12 → verdubbel → 24.",
        "solutionSteps": [
          "6 × 4 = 24 (verdubbel 3 × 4 = 12 → 24)",
          "6 × 6 = 36 (6 × 5 = 30, plus 6 = 36)",
          "6 × 8 = 48 (verdubbel 3 × 8 = 24 → 48)",
          "6 × 9 = 54 (6 × 10 = 60, min 6 = 54)"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-010",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "multiplication_grid",
      "question": "Vul de ontbrekende antwoorden in de tafel van 9",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "single_table",
        "baseNumber": 9,
        "range": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        "hiddenCells": [2, 4, 6, 8]
      },
      "conceptId": "tafels_grid_negen",
      "equivalenceClass": "single-table-grid",
      "variantIndex": 10,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.66,
      "context": "Tafel van 9 rooster",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberBoard",
          "showWhen": "wrong",
          "data": {
            "start": 1,
            "end": 100,
            "highlight": [9, 18, 27, 36, 45, 54, 63, 72, 81, 90],
            "columns": 10,
            "label": "Tafel van 9"
          }
        }
      ],
      "feedback": {
        "explanationText": "De tafel van 9: de ontbrekende antwoorden zijn 9×3=27, 9×5=45, 9×7=63 en 9×9=81. Onthoud: de cijfers van elk antwoord tellen op tot 9 (2+7=9, 4+5=9, 6+3=9, 8+1=9).",
        "solutionSteps": [
          "9 × 3 = 27 (9 × 3 = 10×3 − 3 = 30 − 3, of: 2+7=9)",
          "9 × 5 = 45 (de helft van 9 × 10 = 90, of: 4+5=9)",
          "9 × 7 = 63 (9 × 7 = 70 − 7, of: 6+3=9)",
          "9 × 9 = 81 (9² = 81, of: 8+1=9)"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-011",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "multiplication_grid",
      "question": "Vul de ontbrekende vakjes in het kruistabel-rooster",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "cross_table",
        "rows": [3, 6, 9],
        "cols": [4, 7, 8, 5],
        "hiddenCells": [
          {"row": 0, "col": 1},
          {"row": 0, "col": 3},
          {"row": 1, "col": 0},
          {"row": 1, "col": 2},
          {"row": 2, "col": 1},
          {"row": 2, "col": 3}
        ]
      },
      "conceptId": "tafels_kruistabel_basis",
      "equivalenceClass": "cross-table-grid",
      "variantIndex": 11,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.66,
      "context": "Kruistabel",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kruistabel — rij × kolom",
            "content": "In een kruistabel vermenigvuldig je het getal van de rij met het getal van de kolom. Bijvoorbeeld: rij 3, kolom 7 → 3 × 7 = 21. Werk elk vakje apart uit.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "In een kruistabel vermenigvuldig je rij × kolom. De antwoorden: 3×7=21, 3×5=15, 6×4=24, 6×8=48, 9×7=63, 9×5=45.",
        "solutionSteps": [
          "3 × 7 = 21",
          "3 × 5 = 15",
          "6 × 4 = 24",
          "6 × 8 = 48",
          "9 × 7 = 63",
          "9 × 5 = 45"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-012",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "multiplication_grid",
      "question": "Vul de ontbrekende vakjes in het kruistabel-rooster",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "cross_table",
        "rows": [7, 8],
        "cols": [3, 6, 9, 4, 7],
        "hiddenCells": [
          {"row": 0, "col": 0},
          {"row": 0, "col": 2},
          {"row": 0, "col": 4},
          {"row": 1, "col": 1},
          {"row": 1, "col": 3},
          {"row": 1, "col": 4}
        ]
      },
      "conceptId": "tafels_kruistabel_moeilijk",
      "equivalenceClass": "cross-table-grid",
      "variantIndex": 12,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.68,
      "context": "Moeilijke kruistabel",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Moeilijke tafels — 7 en 8",
            "content": "De tafels van 7 en 8 zijn het lastigst. Trucs: 7×3=21 (tel 7+7+7), 7×9=63 (7×10−7=63), 7×7=49 (kwadraat). 8×6=48 (verdubbel 4×6=24), 8×4=32 (verdubbel 4×4=16), 8×7=56 (5-6-7-8).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De antwoorden: 7×3=21, 7×9=63, 7×7=49, 8×6=48, 8×4=32, 8×7=56.",
        "solutionSteps": [
          "7 × 3 = 21",
          "7 × 9 = 63",
          "7 × 7 = 49",
          "8 × 6 = 48",
          "8 × 4 = 32",
          "8 × 7 = 56"
        ]
      }
    },
    {
      "id": "REK-TAFELS-BASIS-013",
      "familyId": "REK-TAFELS-BASIS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_recall",
      "questionType": "true_false_series",
      "question": "Klopt deze tafelsom? Beoordeel per stelling.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "6 × 7 = 42", "isTrue": true },
          { "text": "8 × 9 = 71", "isTrue": false },
          { "text": "7 × 8 = 56", "isTrue": true },
          { "text": "9 × 6 = 56", "isTrue": false }
        ]
      },
      "conceptId": "tafels_automatisering_check",
      "equivalenceClass": "true-false-check",
      "variantIndex": 13,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.70,
      "context": "Tafels automatiseren",
      "pedagogy": {
        "dok": 1,
        "cognitiveLevel": "comprehension",
        "misconceptionTags": [
          { "id": "rek.multiplication-table-error", "label": "Verwart 8×9 (=72) met buurproduct" },
          { "id": "rek.multiplication-table-error", "label": "Verwart 9×6 (=54) met 7×8 (=56)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Snelle tafelcheck",
            "content": "Controleer elk product: 6×7=42 ✓, 8×9=72 (niet 71!), 7×8=56 ✓, 9×6=54 (niet 56!). De tafels van 7, 8 en 9 zijn de moeilijkste — extra oefenen helpt.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stelling 1: 6×7=42 ✓ klopt. Stelling 2: 8×9=72 (niet 71) — fout. Stelling 3: 7×8=56 ✓ klopt. Stelling 4: 9×6=54 (niet 56, dat is 7×8) — fout.",
        "solutionSteps": [
          "6 × 7 = 42 → klopt ✓",
          "8 × 9 = 72 → 71 klopt niet",
          "7 × 8 = 56 → klopt ✓",
          "9 × 6 = 54 → 56 klopt niet (dat is 7×8)"
        ]
      }
    }
  ]
}